import { mtc } from '@/styles'

interface LoaderProps extends React.SVGProps<SVGSVGElement> {
  size?: number
  className?: string
  /**
   * Render the loader inline (i.e. `display: inline-flex`) instead of
   * full-block/flex-centered.
   */
  inline?: boolean
  /**
   * When `false`, nothing is rendered. When `true`, the spinner
   * shows and animates.
   */
  active?: boolean
}

export function Loader({
  size = 24,
  className,
  inline = false,
  active = true,
  ...props
}: LoaderProps) {
  if (!active) return null

  // pick wrapper tag and classes based on `inline`
  const Wrapper = inline ? 'span' : 'div'
  const wrapperClasses = inline
    ? 'inline-flex items-center justify-center'
    : 'flex items-center justify-center h-full w-full'

  return (
    <Wrapper className={wrapperClasses}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={mtc('animate-spin text-neutral-600', className)}
        {...props}
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
    </Wrapper>
  )
}
